import { css } from 'aphrodite';
import { CameraIcon } from '../../components/svgs/icons/CameraIcon';
import { Button } from '../Button';
import { s } from './styles';

interface AddMediaEmptyStateProps {
	title?: string;
	subtitle?: string;
	onAddMedia: () => void;
}

/**
 * Compact empty state for media/image selection.
 * Displays an icon, title, subtitle, and single "Add Media" button
 * that opens the unified image dialog.
 */
export function AddMediaEmptyState({ title = 'No image selected', subtitle, onAddMedia }: AddMediaEmptyStateProps) {
	return (
		<div className={css(s.container)} role='status' aria-live='polite'>
			<div className={css(s.icon)} aria-hidden='true'>
				<CameraIcon fillColor='currentColor' width={32} height={29} />
			</div>
			<h3 className={css(s.title)}>{title}</h3>
			{subtitle && <p className={css(s.subtitle)}>{subtitle}</p>}
			<Button type='button' variant='primary' size='default' onClick={onAddMedia}>
				Add Media
			</Button>
		</div>
	);
}
